import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticatorService } from '@fitnesspassport/ui-angular';
import { DatadogActions } from '@fp/enums';
import {
  AuthenticationService,
  CommonService,
  DatadogService,
  HttpDAO,
} from '@fp/services';
import { signInWithRedirect } from 'aws-amplify/auth';
import { RouterConstant } from 'src/app/constant/routerconstant';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  submitted: Boolean;
  loading: Boolean;
  isFederatedUserLoginLoading: Boolean;
  returnUrl: String;
  email = '';
  password = '';
  RouterConstant = RouterConstant;
  httpdao: HttpDAO | null;

  // Authenticator
  public _authServices;
  public _authFormFields;

  constructor(
    private route: ActivatedRoute,
    public authService: AuthenticationService,
    private http: HttpClient,
    public commonService: CommonService,
    private authenticator: AuthenticatorService,
    private datadogService: DatadogService,
  ) {
    this._authServices = authService.AuthServices;
    this._authFormFields = authService.AuthFormFields;
  }

  get signupErrors() {
    return this.authService.signupErrors;
  }

  get countryCode() {
    return this.authService.countryCode;
  }

  async ngOnInit() {
    this.submitted = false;
    this.loading = false;
    this.isFederatedUserLoginLoading = false;
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.httpdao = new HttpDAO(this.http);
    this.commonService.App.currentLogin = true;
    this.commonService.App.opened = false;
    setTimeout(() => {
      // Lifecycle does not match UI state, this ensures component is mounted.
      const currentUrl = this.route.snapshot.url.join('/');
      if (currentUrl === RouterConstant.ROUTER_SIGNUP) {
        this.authenticator.toSignUp();
      }
    }, 0);
  }

  private prevState: string = '';
  private currentState: string = '';

  @HostListener('click', ['$event.target'])
  onClick(target: HTMLElement) {
    const id = target.id;
    const text = target.innerText;
    if (/^tab(.*)-1$/.test(id) && text === 'Create Account') {
      this.currentState = 'signUp';
      if (this.currentState !== this.prevState) {
        this.datadogService.addAction(
          DatadogActions[DatadogActions.LoginSignupStarted],
        );
        this.prevState = this.currentState;
      }
    }
    if (id === '' && text === 'Create Account' && this.prevState === 'signUp') {
      this.currentState = 'signUpClick';
      this.datadogService.addAction(
        DatadogActions[DatadogActions.LoginSignupCreateAccountClicked],
      );
      this.prevState = this.currentState;
    }
    if (id === '' && text === 'Confirm' && this.prevState === 'signUpClick') {
      this.currentState = 'confirmSignUp';
      this.datadogService.addAction(
        DatadogActions[DatadogActions.LoginConfirmSignupClicked],
      );
      this.prevState = this.currentState;
    }
  }

  public forgotPassword() {
    this.authenticator.toForgotPassword();
  }

  public async signInWithAzureAD() {
    await signInWithRedirect({
      provider: {
        custom: 'AzureAD',
      },
    });
  }

  public get resetPasswordDestinationInfo() {
    return `A verification code has been sent to ${this.resetPasswordDestination}`;
  }

  public get resetPasswordDestination() {
    return this.authService.resetPasswordCodeDelivery?.destination;
  }
}
